import React, { useEffect, useState } from 'react'

import styles from '../styles/DateRange.module.scss'

import moment from 'moment'
import InsightsPieChart from '../pages/insights/InsightsPieChart'
import PartyStatsDisplay from '../pages/insights/PartyStatsDisplay'
import PlayAgeStatsDisplay from '../pages/insights/PlayAgeStatsDisplay'
import {
  computePartyInsights,
  computePlayAgeStats,
  emptyPartyStats,
  fetchPartyBookingsInRange,
  fetchPlayBookingsInRange
} from '../pages/insights/insightsStats'

const DateRange = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  count,
  setCount,
  duration,
  setDuration,
  bookingType = 'play'
}) => {
  const [rangeMode, setRangeMode] = useState('Bookings')
  const [ageStats, setAgeStats] = useState({})
  const [pieData, setPieData] = useState([])
  const [partyStats, setPartyStats] = useState(emptyPartyStats())

  const isParty = bookingType === 'party'
  const countLabel = isParty ? 'Parties' : rangeMode

  const fetchRange = async (rangeStart, rangeEnd, mode) => {
    if (!rangeStart || !rangeEnd) return

    try {
      if (isParty) {
        const bookings = await fetchPartyBookingsInRange(
          rangeStart,
          rangeEnd,
          mode
        )
        const stats = computePartyInsights(bookings)
        setPartyStats(stats)
        setPieData(stats.partyTypes)
        setCount(stats.totalParties)
        setAgeStats({})
      } else {
        const bookings = await fetchPlayBookingsInRange(
          rangeStart,
          rangeEnd,
          mode
        )
        const { ageStats: stats, pieData: data, visitorCount } =
          computePlayAgeStats(bookings)
        setAgeStats(stats)
        setPieData(data)
        setPartyStats(emptyPartyStats())
        setCount(visitorCount)
      }
    } catch (error) {
      console.log('DateRange fetchRange:', error.message)
    }
  }

  useEffect(() => {
    const days = moment
      .duration(moment(endDate).diff(moment(startDate)))
      .as('days')
    setDuration(Math.abs(days) + 1)
  }, [startDate, endDate, setDuration])

  useEffect(() => {
    if (startDate && endDate) {
      fetchRange(startDate, endDate, rangeMode)
    }
    
  }, [bookingType])

  const handleRange = async (rangeStart, rangeEnd, mode) => {
    await fetchRange(rangeStart, rangeEnd, mode)
  }

  return (
    <div className={styles.DateRange}>
      <div className={styles.dateRange}>
        <label htmlFor="start">Start date:</label>
        <input
          type="date"
          name="date-start"
          min="2000-01-01"
          max="2050-12-31"
          value={startDate}
          onChange={async event => {
            const value = event.target.value
            await handleRange(value, endDate, rangeMode)
            setStartDate(value)
          }}
        />
        <label htmlFor="end">End date:</label>
        <input
          type="date"
          name="date-end"
          min="2000-01-01"
          max="2050-12-31"
          value={endDate}
          onChange={async event => {
            const value = event.target.value
            await handleRange(startDate, value, rangeMode)
            setEndDate(value)
          }}
        />
        <select
          value={rangeMode}
          onChange={async event => {
            const value = event.target.value
            await handleRange(startDate, endDate, value)
            setRangeMode(value)
          }}>
          <option value="Orders">Orders</option>
          <option value="Bookings">Bookings</option>
        </select>
        <p>
          {countLabel}: {count}
        </p>
        {!isNaN(duration) && duration > 0 && (
          <>
            <p>Days: {duration}</p>
            <p>
              Daily Average: {Math.round(count / duration)} {countLabel} per day
            </p>
          </>
        )}
      </div>
      <div className={styles.charts}>
        <InsightsPieChart data={pieData} size="compare" />
        <div className={styles.statsPanel}>
          {isParty ? (
            <PartyStatsDisplay partyStats={partyStats} />
          ) : (
            <PlayAgeStatsDisplay ageStats={ageStats} />
          )}
        </div>
      </div>
    </div>
  )
}

export default DateRange
